import { createStore, combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { devToolsEnhancer } from 'redux-devtools-extension';

import loginReducer from './loginReducer';

const rootReducer = combineReducers({
  loginData: loginReducer,
});

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ['loginData'],
  blacklist: []
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(persistedReducer, devToolsEnhancer());

export const persistor = persistStore(store);